/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerFeedMill } from '../../models/customer-feed-mill';

export interface FindByCustomerFeedMillId_1$Params {
  customerId: number;
  feedMillId: number;
}

export function findByCustomerFeedMillId_1(http: HttpClient, rootUrl: string, params: FindByCustomerFeedMillId_1$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerFeedMill>> {
  const rb = new RequestBuilder(rootUrl, findByCustomerFeedMillId_1.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.path('feedMillId', params.feedMillId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerFeedMill>;
    })
  );
}

findByCustomerFeedMillId_1.PATH = '/api/customer/feedMill/{customerId}/feedMill/{feedMillId}';
